import utils from '@/utils'

export const teacher = {
  namespaced: true,
  state: {
    list: {
      data: [],
      meta: {},
    },
    listLoading: false,
    detail: {},
    detailLoading: false,
    deleteLoading: false,
    searchList: {
      data: [],
      meta: {},
    },
    searchListLoading: false,
  },
  getters: {
    list: (state) => {
      return state.list
    },
    detail: (state) => {
      return state.detail
    },
    isListLoading: (state) => {
      return state.listLoading
    },
    isDetailLoading: (state) => {
      return state.detailLoading
    },
    isDeleteLoading: (state) => {
      return state.deleteLoading
    },
    searchList: (state) => {
      return state.searchList
    },
    isSearchListLoading: (state) => {
      return state.searchListLoading
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data
    },
    setDetail(state, data) {
      state.detail = data
    },
    setListLoading(state, data) {
      state.listLoading = data
    },
    setDetailLoading(state, data) {
      state.detailLoading = data
    },
    setDeleteLoading(state, data) {
      state.deleteLoading = data
    },
    setSearchList(state, data) {
      state.searchList = data
    },
    setSearchListLoading(state, data) {
      state.searchListLoading = data
    },
  },
  actions: {
    async getList({ commit, dispatch }, filters) {
      commit('setListLoading', true)
      try {
        const response = await axios.get(`/api/teachers`, {
          params: filters,
          paramsSerializer: (params) => {
            return qs.stringify(params, {
              arrayFormat: 'indices',
              allowDots: true,
              skipNulls: true,
            })
          },
        })
        commit('setList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'teacher/getList', error },
          { root: true }
        )
      } finally {
        commit('setListLoading', false)
      }
    },
    async getDetail({ commit }, id) {
      commit('setDetailLoading', true)
      const response = await axios.get(`/api/teachers/${id}`)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async create({ commit }, data) {
      commit('setDetailLoading', true)
      const response = await axios.post('/api/teachers', data)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async update({ commit }, data) {
      commit('setDetailLoading', true)
      const response = await axios.put(`/api/teachers/${data.id}`, data)
      commit('setDetail', response.data.data)
      commit('setDetailLoading', false)
    },
    async delete({ commit }, id) {
      commit('setDeleteLoading', true)
      await axios.delete(`/api/teachers/${id}`)
      commit('setDeleteLoading', false)
    },
    async search({ commit, dispatch }, { search, filters }) {
      commit('setSearchListLoading', true)
      try {
        const response = await axios.get(`/api/teachers`, {
          params: {
            name: search,
            ...filters,
          },
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setSearchList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'student/search', error },
          { root: true }
        )
      } finally {
        commit('setSearchListLoading', false)
      }
    },
  },
}
